// procedures.ts
// Service functions for interacting with procedure-related APIs.
// Provides retrieval operations for procedures by practice.

import { tokenAxios } from "@/utils/axios";
import { ProcedureResponse } from "@/types/my-tasks";
import { ProcArgs } from "@/types/procedure";

/**
 * Fetches procedures for a given practice.
 * @param params - Parameters including practiceId and any filters
 * @returns The procedure response object
 */
export const getProcedures = async (params: ProcArgs) => {
  const { data } = await tokenAxios().get<ProcedureResponse>(`/api/procedures/${params.practiceId}`, {
    params,
  });
  return data;
};
